import React from "react";
import { Progress } from "reactstrap";

/**
 * HpBar — barra de vida do personagem.
 * Cores progressivas: vermelho < 30%, amarelo < 60%, verde >= 60%.
 */
class HpBar extends React.Component {
  render() {
    var current = parseInt(this.props.currentHp) || 0;
    var max = parseInt(this.props.maxHp) || 100;
    var pct = Math.max(0, Math.min(100, Math.round((current / max) * 100)));
    var color = pct < 30 ? '#dc3545' : pct < 60 ? '#ffc107' : '#28a745';
    var compact = this.props.compact;

    return (
      <div style={{ width: '100%' }}>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <span style={{ fontSize: compact ? '0.7rem' : '0.85rem', fontWeight: 600 }}>
            <i className="fas fa-heart mr-1" style={{ color: color }} />
            HP
          </span>
          <span style={{ fontSize: compact ? '0.7rem' : '0.85rem', color: color, fontWeight: 700 }}>
            {current} / {max}
          </span>
        </div>
        <Progress
          value={pct}
          style={{ height: compact ? '8px' : '14px', backgroundColor: '#f0f0f0' }}
          barStyle={{
            background: 'linear-gradient(90deg, ' + color + ' 0%, ' + color + 'cc 100%)',
            transition: 'width 0.4s ease'
          }}
        />
      </div>
    );
  }
}

export default HpBar;
